import DashboardLayout from '@/layouts/DashboardLayout.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import auth from '@/middleware/auth';
import type { Middleware } from '@/types/router';
import { QuranTutorsRouteName } from '@/types/router/name/quran-tutors';
import { QuranTutorsRoutePath } from '@/types/router/path/quran-tutors';

export default [
    {
        path: QuranTutorsRoutePath.Registration,
        name: QuranTutorsRouteName.Registration,
        component: () => import('@/pages/quran-tutors/registration/index.vue'),
        meta: {
            group: 'quran-tutors',
            sub: 'registration',
            title: 'Pendaftaran Guru Ngaji',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: QuranTutorsRoutePath.Batch,
        name: QuranTutorsRouteName.Batch,
        component: () => import('@/pages/quran-tutors/registration/batch/index.vue'),
        meta: {
            group: 'quran-tutors',
            sub: 'batch',
            title: 'Pendaftaran Guru Ngaji',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: QuranTutorsRoutePath.Verification,
        name: QuranTutorsRouteName.Verification,
        component: () => import('@/pages/quran-tutors/registration/verification/index.vue'),
        meta: {
            group: 'quran-tutors',
            sub: 'verification',
            title: 'Review Data Guru Ngaji',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: QuranTutorsRoutePath.InstructorRegistration,
        name: QuranTutorsRouteName.InstructorRegistration,
        component: () => import('@/pages/quran-tutors/instructor-registration/index.vue'),
        meta: {
            group: 'quran-tutors',
            sub: 'instructor-registration',
            title: 'Pendaftaran Pengajar',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: QuranTutorsRoutePath.InstructorVerification,
        name: QuranTutorsRouteName.InstructorVerification,
        component: () =>
            import('@/pages/quran-tutors/instructor-registration/verification/index.vue'),
        meta: {
            group: 'quran-tutors',
            sub: 'instructor-verification',
            title: 'Tinjau Pendaftaran Pengajar',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: QuranTutorsRoutePath.InstructorQuranMethod,
        name: QuranTutorsRouteName.InstructorQuranMethod,
        component: () =>
            import('@/pages/quran-tutors/instructor-registration/quran-method/index.vue'),
        meta: {
            group: 'quran-tutors',
            sub: 'instructor-registration',
            title: 'Metode Pembelajaran',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: QuranTutorsRoutePath.TeachingVideos,
        name: QuranTutorsRouteName.TeachingVideos,
        component: () => import('@/pages/quran-tutors/teaching-videos/index.vue'),
        meta: {
            group: 'quran-tutors',
            sub: 'teaching-videos',
            title: 'Video Mengajar',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: QuranTutorsRoutePath.List,
        name: QuranTutorsRouteName.List,
        component: () => import('@/pages/quran-tutors/list/index.vue'),
        meta: {
            group: 'quran-tutors',
            sub: 'list',
            title: 'List Guru Ngaji',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: QuranTutorsRoutePath.TutorDetail,
        name: QuranTutorsRouteName.TutorDetail,
        component: () => import('@/pages/quran-tutors/list/detail/index.vue'),
        meta: {
            group: 'quran-tutors',
            sub: 'detail-list',
            title: 'Detail List Guru Ngaji',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: QuranTutorsRoutePath.TutorDetailProfile,
        name: QuranTutorsRouteName.TutorDetailProfile,
        component: () => import('@/pages/quran-tutors/list/detail/profile/index.vue'),
        meta: {
            group: 'quran-tutors',
            sub: 'detail-profile',
            title: 'Detail Profile Guru Ngaji',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: QuranTutorsRoutePath.ValidateActivity,
        name: QuranTutorsRouteName.ValidateActivity,
        component: () => import('@/pages/quran-tutors/validate-activity/index.vue'),
        meta: {
            group: 'quran-tutors',
            sub: 'validate-activity',
            title: 'Validasi Kegiatan Ngaji',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: QuranTutorsRoutePath.ValidateActivityVerification,
        name: QuranTutorsRouteName.ValidateActivityVerification,
        component: () => import('@/pages/quran-tutors/validate-activity/verification/index.vue'),
        meta: {
            group: 'quran-tutors',
            sub: 'verification',
            title: 'Review Data Kegiatan Mengajari',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: QuranTutorsRoutePath.ManualPresence,
        name: QuranTutorsRouteName.ManualPresence,
        component: () => import('@/pages/quran-tutors/validate-activity/presence/index.vue'),
        meta: {
            group: 'quran-tutors',
            sub: 'manual-presence',
            title: 'Input Presensi Manual',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: QuranTutorsRoutePath.Incentive,
        name: QuranTutorsRouteName.Incentive,
        component: () => import('@/pages/quran-tutors/incentive/index.vue'),
        meta: {
            group: 'quran-tutors',
            sub: 'incentive',
            title: 'Insentif Guru Ngaji',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: QuranTutorsRoutePath.Disbursement,
        name: QuranTutorsRouteName.Disbursement,
        component: () => import('@/pages/quran-tutors/disbursement/index.vue'),
        meta: {
            group: 'quran-tutors',
            sub: 'disbursement',
            title: 'Penyaluran Dana',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: QuranTutorsRoutePath.Report,
        name: QuranTutorsRouteName.Report,
        component: () => import('@/pages/quran-tutors/disbursement/report/index.vue'),
        meta: {
            group: 'quran-tutors',
            sub: 'disbursement-report',
            title: 'Laporan Pencairan',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: QuranTutorsRoutePath.ReportDetail,
        name: QuranTutorsRouteName.ReportDetail,
        component: () => import('@/pages/quran-tutors/disbursement/report/detail/index.vue'),
        meta: {
            group: 'quran-tutors',
            sub: 'report-detail',
            title: 'Detail Laporan Pencairan',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    }
];
